import * as React from "react"
const IconProyectos = ({ width, height }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 60 60"
        width={width}
        height={height}
    >
        <path
            d="M0 0h60v60H0z"
            style={{
                fill: "#eae0d8",
            }}
        />
        <path
            d="M1.97 1.81h56.32v56.32H1.97z"
            style={{
                fill: "none",
                stroke: "#354060",
                strokeMiterlimit: 10,
            }}
        />
        <path
            d="M44.21 12.85h3.17c.15 0 .45.61.38.8l-.04 36.11-.3.37-28.84.05c-.23.05-.54-.39-.54-.55v-3h-3.17c-.15 0-.45-.61-.38-.8l.04-36.11.3-.37 28.84-.05c.23-.05.54.39.54.55v3Zm-1.27-2.36H15.75l-.08 34.96h27.28V10.49Zm3.55 3.55h-2.28v32.05c0 .14-.32.55-.46.55H19.3V49h27.19V14.04Z"
            style={{
                fill: "#354060",
            }}
        />
        <path
            d="m19.7 16.42 19.36.03c.55.36.42 1-.2 1.14H19.85c-.7-.06-.73-.88-.15-1.17ZM19.61 23.76l19.16-.02c.88 0 .81 1.12 0 1.19H19.93c-.67-.06-.89-.78-.32-1.17ZM19.7 38.37l19.15-.02c.81.09.7 1.13-.08 1.19H19.93c-.7-.05-.91-.91-.23-1.17ZM19.78 31.03l18.98-.02c.81.07.88 1.19 0 1.19H19.84c-.72-.04-.74-1.02-.07-1.17Z"
            style={{
                fill: "#354060",
            }}
        />
    </svg>
)
export default IconProyectos
